import { InjectionToken } from '@angular/core';

export const icBrand = new InjectionToken<string>('icBrand');
export const icBrandFactory = (icWorkingDomain: string) => {
  // return 'tests2'; // TODO only for local testing
  // return 'alitermica'; // TODO only for local testing

  if (!window.location.hostname.includes(icWorkingDomain)) {
    return null;
  }

  const brandingDomain = window.location.hostname.replace(icWorkingDomain, '').replace(/\.$/, '');

  return brandingDomain !== '' ? brandingDomain : null;
};
